const config = {
  env: "local",
  // Hardcoded API endpoints (kept for reference — active value comes from .env)
  // apiUrl: "http://localhost:5589/admin/",
  // apiUrl: "http://65.1.134.152:8515/admin/",
  // apiUrl: "https://392q0kfx-5589.inc1.devtunnels.ms/admin/",
  // apiUrl: "https://api.gdgoenkahealthcare.com/admin/",
  apiUrl: process.env.REACT_APP_API_URL || "https://api.gdgoenkahealthcare.com/admin/",
  shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/",
};

export default config;
